import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  labelText: {
    textAlign: 'left',
    marginLeft: '4%',
    fontSize: '15px',
    fontWeight: '500',
    marginTop: '10px'
  }
}))

export default useStyles
